import React, { Component } from 'react';
import Filter from './Filter';
import List from './List';
import Fetch from '../../../../../common/Fetch';
import API_URL from '../../../../../common/url';
import dictCache from '../../../../../common/dictCache';

class TablePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
            },
            sortParams: {},
            load: null,
            areaOptions: [],
        };
    }

    componentDidMount() {
        this.loadAreaList();
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            Fetch.post(API_URL.common.queryAllInvestigationArea, {}).then(cb).catch(error => {
                console.error(error);
            });
        }, res => {
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({ areaOptions });
        });
    }

    
    search = () => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            load: {},
            pagination,
        });
    }

    handleChange = (params, isLoad) => {
        const settings = {
            ...params,
        };
        if (isLoad) {
            settings.load = {};
        }
        this.setState(settings);
    }

    render() {
        const { searchParams, businessList, clientHeight, onChange, notice } = this.props;
        const { sortParams, pagination, load, areaOptions } = this.state;
        const height = clientHeight - 72 - 94 - 45 - 60;

        return (
            <div className="pane-item-content">
                <Filter
                    search={this.search}
                    sortParams={sortParams}
                    searchParams={searchParams}
                    businessList={businessList}
                    onChange={onChange}
                    areaOptions={areaOptions}
                />
                <List
                    load={load}
                    height={height}
                    notice={notice}
                    sortParams={sortParams}
                    pagination={pagination}
                    searchParams={searchParams}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}

export default TablePage;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestToDo/UnregisterRequest/TablePage/index.js